import { toQueryString } from './urls';

const getBase = (url: string) => {
    if (!url) {
        return '';
    }
    if (url.includes('#')) {
        return url.substring(0, url.indexOf('#'));
    }
    if (url.includes('?')) {
        return url.substring(0, url.indexOf('?'));
    }
    return url;
};

// Returns the canonical url for the page (only `page` may appear in the query string)
export const buildCanonicalUrl = (canonicalPageUrl: string, pageNum: number) => {
    const base = getBase(canonicalPageUrl);

    const withPage: Record<string, unknown> = {};
    if (pageNum && pageNum !== 1) {
        withPage.page = pageNum;
    }

    const query = toQueryString(withPage);

    return query === '' ? base : `${base}?${query}`;
};

export const pageSlicer = (catalog: any, count?: number | 'all', page: number = 1) => {
    if (count === 'all' || typeof count === 'undefined') {
        return catalog;
    }
    const pages = Math.ceil(catalog.length / count);
    let currentPage = page;
    if (page > pages) {
        currentPage = pages;
    }
    const start = (currentPage - 1) * count;
    return catalog.slice(start, start + count);
};

export const getPageSizeFromCookie = (cookie: number | 'all') => (cookie === 'all' ? 'all' : Number(cookie));
